function axiosLikeError(
  error: unknown,
): error is {
  response?: {
    status?: number;
    data?: {
      error?: { message?: string; status?: number } | string;
      message?: string;
    };
  };
} {
  return typeof error === "object" && error !== null && "response" in error;
}

export function getHttpStatus(error: unknown): number | undefined {
  if (axiosLikeError(error)) {
    return error.response?.status;
  }
  return undefined;
}

export function getApiErrorMessage(
  error: unknown,
  fallback = "Ocurrió un error inesperado. Intenta de nuevo.",
): string {
  if (axiosLikeError(error)) {
    const data = error.response?.data;
    const apiError = data?.error;
    const status = error.response?.status;

    if (typeof apiError === "string" && apiError.trim()) {
      return apiError;
    }

    if (
      typeof apiError === "object" &&
      apiError &&
      typeof apiError.message === "string" &&
      apiError.message.trim()
    ) {
      const message = apiError.message.trim();
      if (status === 403 && message.toLowerCase() === "forbidden") {
        return fallback;
      }
      return message;
    }

    if (typeof data?.message === "string" && data.message.trim()) {
      const message = data.message.trim();
      if (status === 403 && message.toLowerCase() === "forbidden") {
        return fallback;
      }
      return message;
    }

    if (status === 403) {
      return fallback;
    }
  }

  if (error instanceof Error && error.message.trim()) {
    return error.message;
  }

  return fallback;
}
